<template>
  <div :class="$style.deviceEncryptedRow">
    <div :class="$style.selectWrapper">
      <Select
        name="disk encryption operator"
        :options="options"
        placeholder="Select Operator"
        :rules="'required'"
        :value="model.status"
        @input="(newStatus) => setAttribute('status', newStatus)"
      />
    </div>

    <div :class="$style.selectWrapper">
      <InputText
        v-model="deviceValue"
        isDisabled
      />
    </div>
  </div>
</template>

<script>
import { ExpressionStatus } from 'client/Security/data/Condition';
import { InputText, Select } from '@jumpcloud/ui-components';
import ConditionDeviceEncrypted from 'client/Security/data/ConditionDeviceEncrypted';

export default {
  name: 'ConditionRowDeviceEncrypted',

  components: {
    InputText,
    Select,
  },

  props: {
    value: {
      type: ConditionDeviceEncrypted,
      default: () => new ConditionDeviceEncrypted(),
    },
  },

  data() {
    return {
      deviceValue: 'Enabled on Device',

      model: null,

      options: [
        { name: 'Is', value: ExpressionStatus.include },
        { name: 'Is Not', value: ExpressionStatus.exclude },
      ],
    };
  },

  beforeMount() {
    this.model = this.value;

    this.$emit('input', this.model);
  },

  methods: {
    setAttribute(key, value) {
      this.model[key] = value;

      this.$emit('input', this.model);
    },
  },
};
</script>

<style module>
.deviceEncryptedRow {
  display: grid;
  gap: 1em;
  grid-template-columns: 1fr 1fr;
}

.selectWrapper {
  --input-wrapper-width: auto;
  --input-wrapper-min-width: 10ch;
}
</style>
